import React, { useMemo } from 'react';
import { WaterIcon } from '../../../shared/assets/icons';
import { h4Style, labelStyle } from '../../../shared/styles/text';
import { Pedestal, Valve } from '../../../shared/types/server-types';
import {
  reactiveCardStyle,
  sourceCardStyle,
  determineCardStyle,
} from './card-styles';
import { cx } from '@emotion/css';
import { sourceLabels } from '../../../shared/types/enums';

interface IValveCardProps {
  valve: Valve;
  setModalVisible(value: boolean): void;
  pedestal: Pedestal;
}

export const ActivateMoreValveCard = (props: IValveCardProps): JSX.Element => {
  const { valve, setModalVisible, pedestal } = props;
  const { type, position } = valve;

  const cardStyle = useMemo(() => determineCardStyle(valve), [valve]);

  return (
    <button
      type="button"
      className={cx(sourceCardStyle, reactiveCardStyle(cardStyle))}
      onClick={() => {
        setModalVisible(true);
      }}
    >
      <figure>
        <h4 className={h4Style}>
          {sourceLabels[type]} {position}
        </h4>
        <WaterIcon />
      </figure>
      <label className={labelStyle}>
        ID {pedestal.identifier.toUpperCase()}
      </label>
    </button>
  );
};
